








import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

const CommonTimeline = defineComponent({
  props: {
    log: {},
    index: {},
    length: {},
  },
  setup() {
    function dateFormat(date: string) {
      return useFormat.date(date).displayShortThaiDateTime();
    }
    return {
      dateFormat,
    };
  },
});

export default CommonTimeline;
